import React, { useEffect, useState } from "react";
import apiServices from "../../../../services/apiServices";
import {
  fetchContactsRequest,
  updateContacts,
} from "../../../../Store/Buzzcom/actions";
import { useDispatch, useSelector } from "react-redux";
import { getSocket } from "../../../../services/socketService";
import { Badge, Button, Col, Container, Image, Row } from "react-bootstrap";
import "./ManageFriendRequests.css"; // Add a custom CSS file for specific styling adjustments
import Avatar from "../../../../Assets/components/Avatar/Avatar";

const buttons = [
  { id: "received", label: "Add Requests" },
  { id: "sent", label: "Sent Requests" },
];

const ManageFriendRequests = () => {
  const socket = getSocket();
  const dispatch = useDispatch();
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [pendingRequests, setPendingRequests] = useState(0); // Example count for badge
  const [sentRequests, setSentRequests] = useState(0); // Example count for badge
  const [activeButton, setActiveButton] = useState("sent");
  const [loader, setLoader] = useState(false);
  const userId = localStorage.getItem("userId");

  const handleButtonClick = (buttonId) => {
    setFilteredContacts([]);
    setActiveButton(buttonId);
  };

  const callFilterApi = async (userId) => {
    let data = {
      requestedBy: userId,
      status: activeButton === "received" ? "pending" : "requested",
    };
    let response = await apiServices.filterContact(
      data.requestedBy,
      data.status
    );
    console.log("res objects", response?.data);

    setFilteredContacts(response?.data);
    setLoader(false);
  };

  const handleAcceptAndReject = async (chat, req) => {
    try {
      const senderId =
        userId === chat?.contacts[0].userId
          ? chat?.contacts[0].userId
          : chat?.contacts[1].userId;
      const receiverId =
        userId === chat?.contacts[1].userId
          ? chat?.contacts[0].userId
          : chat?.contacts[1].userId;
      let obj = { requestedBy: senderId, conversationId: chat?.conversationId };
      let response =
        req === "accept"
          ? await apiServices.acceptRequest(obj)
          : await apiServices.declineRequest(obj);
      console.log("filter response", response);
      if (response?.status === "200") {
        if (req === "accept") {
          socket.emit("new-contact-request", {
            from: senderId,
            to: receiverId,
            type: "acceptContact",
          });

          dispatch(fetchContactsRequest(senderId));
        }
      }
      callFilterApi(userId);
    } catch (error) {
      console.log("error in handleAcceptAndReject", error);
    }
  };

  const handleCancelRequest = async (message) => {
    setLoader(true);
    let obj = { ID: message?._id };
    await apiServices.cancelRequest(obj);
    callFilterApi(userId);
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    callFilterApi(userData?.id);
  }, [activeButton]);

  return (
    <Container className="manage-friend-requests">
      <div className="d-flex justify-content-center border-bottom">
        {buttons.map(({ id, label }) => (
          <div
            className={`friendRequestButtons ${
              id === "received" && "AddRequestButtonBorder"
            }`}
          >
            <Button
              key={id}
              variant="text"
              className={`request-tab ${
                activeButton === id ? "active-tab" : ""
              }`}
              onClick={() => handleButtonClick(id)}
            >
              {label}
              {((id === "received" && pendingRequests) ||
                (id === "sent" && sentRequests)) > 0 && (
                <Badge bg="warning" className="ms-2">
                  {pendingRequests}
                </Badge>
              )}
            </Button>
          </div>
        ))}
      </div>

      <div className="friend-requests">
        {activeButton === "received" && (
          <div>
            {filteredContacts?.length > 0 ? (
              filteredContacts.map((message) => (
                <div
                  key={message._id}
                  className="request-card d-flex align-items-center border rounded"
                >
                  <div className="position-relative">
                    <Avatar
                      name={message?.contacts[1].name}
                      imageUrl={message?.imageUrl}
                      size={40}
                    />
                    {/* <span className="online-indicator" style={{backgroundColor: `${onlineUsers.includes(message?.contacts[1].userId ? "" : "")}`}}></span> */}
                  </div>
                  <div className="d-flex flex-column gap-2">
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-0 text-dark">
                        {message?.contacts[1].name}
                      </h6>
                    </div>
                    <div className="d-flex flex-row">
                      <Button
                        variant="success"
                        className="me-2 btn-sm acceptButton"
                        style={{
                          padding: "unset",
                          paddingInline: "14px",
                          marginBottom: "5px",
                        }}
                        onClick={() => handleAcceptAndReject(message, "accept")}
                      >
                        Accept
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-sm declineButton"
                        style={{
                          padding: "unset",
                          paddingInline: "14px",
                          marginBottom: "5px",
                        }}
                        onClick={() => handleAcceptAndReject(message, "reject")}
                      >
                        Decline
                      </Button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center mt-4">You have no received requests.</p>
            )}
          </div>
        )}

        {activeButton === "sent" && (
          <div>
            {filteredContacts?.length > 0 ? (
              filteredContacts.map((message) => (
                <div
                  key={message._id}
                  className="request-card d-flex align-items-center border rounded"
                >
                  <div className="position-relative">
                    <Avatar
                      name={message?.contacts[1].name}
                      imageUrl={message?.imageUrl}
                      size={40}
                    />

                    {/* <span className="online-indicator"></span> */}
                  </div>
                  <div className="flex flex-column ms-3 flexItems-center gap-3">
                    <h6 className="mb-2 text-black">
                      {message?.contacts[1].name}
                    </h6>
                    <Button
                      variant="danger"
                      className="btn-sm cancelButton"
                      style={{
                        padding: "unset",
                        paddingInline: "12px",
                        marginBottom: "5px",
                      }}
                      onClick={() => handleCancelRequest(message)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center mt-4">You have no sent requests.</p>
            )}
          </div>
        )}
      </div>
    </Container>
  );
};

export default ManageFriendRequests;
